import axios from "axios";

export const LOGIN_URL = `${process.env.REACT_APP_API_URL}/user/login`;
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
export const ME_URL = `${process.env.REACT_APP_API_URL}/user/user-info`;

export function login(userId, password) {
  return axios.post(LOGIN_URL, { userId, password });
}

export function register(userId, fullname, username, password) {
  return axios.post(REGISTER_URL, { userId, fullname, username, password });
}

export function requestPassword(userId) {
  return axios.post(REQUEST_PASSWORD_URL, { userId });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
